import { GetterTree } from 'vuex';
import RootStateType from './RootStateType.type';

const getters: GetterTree<RootStateType, any> = {
  isAppLoading: (state) => state.isLoading,
  partnerID: (state) => state.partnerID,
};

export default getters;
